// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import {
  intersection as _intersection,
  debounce as _debounce,
  merge as _merge,
} from 'lodash-es';
import $ from 'jquery';
import { FilterableMap } from './_filterableMap';
import { pushTrackerEvent } from '../_googleTagManager';
import { getTextSwitchByElement } from './_textSwitch';
import { runOnPageload } from '../runner-pageload';
import {convertCssDurationToMilliseconds, getQueryVar} from '../_util';
import runOnVisible from '../runner-visible';
import {
  hasVendorConsent,
  watchVendorConsentUpdate,
} from '../plugins/cmp-helpers';
import {CONSENT_GOOGLE_MAPS} from '../consentVendors';
import {
  addConsentPlaceholder,
  removeConsentPlaceholder,
} from '../plugins/cmp-placeholder';
import parsley from 'parsleyjs';
// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'contact-multi-step';
let visibleSummaryFirstTime = false;
let timeStart = null;
let conclusionAlreadySeen = 'no';
// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

export class MultiStepForm {
  constructor(el) {
    this.el = el;
    this.$navElement = $(el).find(`.${baseClass}__nav li`);
    this.$form = $(el).find(`.form--kirinus`);
    this.$submit = $(el).find(`button[type="submit"]`);
    this.$steps = $(el).find(`.form--kirinus__steps`);
    this.$lastStep = $(el).find(`.form--kirinus__step--last-step`);

    this.$stepNext = $(el).find(`.form--kirinus__steps [data-step="next"]`);
    this.$stepPrev = $(el).find(`.form--kirinus__steps [data-step="prev"]`);

    this.$summary = $(el).find(`.form--kirinus__summary`);
    this.$stepBar = $(el).find(`.${baseClass}__percent`);

    runOnVisible(this.el, async () => {
      await this.start();
    });
  }

  async start() {
    let firstDataLayerEvent = false;
    // Open first form step (with invalid input)
    let step = this.$form.find('.is-invalid').closest('.form--kirinus__step').first().data('step') || 1;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const urlStepID = urlParams.get('form-step');

    if (urlStepID) {
      step = urlStepID;
    }

    this.$navElement.eq(step-1).addClass('active');
    this.$form.find('[data-step="'+step+'"]').addClass('active');

    // Remove 'is-invalid' once the input changes (allows step progression after input correction)
    this.$form.find('.is-invalid').on('input propertychange', function(event) {
      $(event.currentTarget)
        .removeClass('is-invalid')
        .next('.invalid-feedback').remove();
    });

    this.parsleyPrepare();

    this.$navElement.on('click', this.onClick.bind(this));
    this.$steps.find('[data-step]').on('click', this.gotoStep.bind(this));

    this.createSummaryButton();
    this.getStep();
    this.$stepBar.css('--last-step', this.getStepsNumber());
    this.$stepBar.append($(`<div class="${baseClass}__percent-number">1/${this.getStepsNumber()}</div>`));

    var self = this; // Speichere den Wert von 'this' in einer Variable

    this.$form.find('.form-control').on('click', function () {
      if (self.$form.find('.form--kirinus__step.active').attr('data-step') === '1') {

        if (firstDataLayerEvent === false) {
          let getStepName = self.$navElement.parent().find('.active').text();

          //@todo OM fragen was mit direct-link gemeint ist.
          self.$form.attr('data-current-position', `step${self.$form.find('.form--kirinus__step.active').attr('data-step')}`);
          self.$form.attr('data-current-element', `inputfield`);

          self.dataLayer(1, getStepName);

          firstDataLayerEvent = true;
        }
      }
    });

    // selectfield
    this.$form.find('.form-select').on('click', function () {
      if (self.$form.find('.form--kirinus__step.active').attr('data-step') === '1') {

        if (firstDataLayerEvent === false) {
          let getStepName = self.$navElement.parent().find('.active').text();

          self.$form.attr('data-current-position', `step${self.$form.find('.form--kirinus__step.active').attr('data-step')}`);
          self.$form.attr('data-current-element', `selectfield`);

          self.dataLayer(1, getStepName);

          firstDataLayerEvent = true;
        }
      }
    });

    this.submitForm();
  }

  parsleyPrepare() {
    // Assign form step attribute to input fields for validation
    const $steps = this.$form.find('.form--kirinus__step');
    $steps.each(function() {
      const groupId = $(this).attr('data-step');
      $(this).find("select").attr('data-parsley-group', `group-${groupId}`);
      $(this).find("textarea").attr('data-parsley-group', `group-${groupId}`);
      $(this).find("input:not([type='hidden'])").attr('data-parsley-group', `group-${groupId}`);
    });
  }

  parsleyValidate() {
    // Prepare input groups, as new fields may have been added by the repeatable container
    this.parsleyPrepare();

    let isValid = false;

    // Determine current input field group
    const currentStep = $('.form--kirinus__step.active').first().attr('data-step');

    this.$form.parsley().whenValidate({
      group: 'group-' + currentStep
    }).done(function() {
      isValid = true
    });

    $('.form--kirinus__step.active select[data-element-type="SingleSelect"]').each(function (){
      if ($(this).hasClass('parsley-error')) {
        $(this).parent().find('.custom-select-opener').addClass('parsley-error');
      }
    });

    return isValid;
  }

  // TODO: #5 Add new custom validation for our existing text field date validator (@Antonio)

  gotoStep(e) {
    e.preventDefault();

    // Abort execution if form is invalid
    if(!this.parsleyValidate()) return;

    let target = e.currentTarget;
    let currentStep = this.$navElement.parent().find('.active');

    this.$form.attr('data-source', target.innerText);

    // this.$form.setAttribute('data-step-level');
    if (target.getAttribute('data-step') === 'next') {
      this.getCheckFields(currentStep);
    } else {
      currentStep.prev().trigger('click');
      this.scrolltoFormTop();
    }
  }

  scrolltoFormTop() {
    let pageHeader = $('.page-header')[0].clientHeight;
    $('html, body').animate({
      scrollTop: $(`.${baseClass}`).offset().top - pageHeader
    }, 500);
  }

  getCheckFields(currentStep) {
    currentStep.next().trigger('click');
    this.scrolltoFormTop();
  }

  createSummaryButton() {
    this.$stepNext.after('<button class="btn btn-primary contact-multi-step__form-summary" type="button">Zur Zusammenfassung</button>');

    let formClass = $(`.${baseClass}`);
    let that = this;

    $('.contact-multi-step__form-summary').on('click', function () {
      if(!that.parsleyValidate()) return;

      // $(this).closest('.kirinus-form').attr('data-current-element', `button-conclusion`);
      $(this).closest('.kirinus-form').attr('data-current-position', `step${$(this).closest('.kirinus-form').find('.form--kirinus__step.active').attr('data-step')}`);

      $(this).removeClass('is-show');
      formClass.find(`button[type="submit"]`).show();
      formClass.find(`.form--kirinus__steps [data-step="next"]`).hide();
      formClass.find(`.form--kirinus__steps [data-step="prev"]`).hide();
      formClass.find(`.${baseClass}__nav li`).parent().removeClass(`${baseClass}__nav--show`);
      formClass.find(`.${baseClass}__percent`).addClass(`${baseClass}__percent--hide`);

      $('.form--kirinus__step.active').removeClass('active');
      $('.form--kirinus__step--last-step').addClass('active');
      that.getSummary();
      that.scrolltoFormTop();

      let lastStepNumber = parseInt(that.$lastStep.attr('data-step'));

      that.dataLayer(lastStepNumber, 'Zusammenfassung', false, 'button-conclusion');
    });
  }

  getSummary() {
    this.$summary.children().remove();

    $('.form--kirinus__step:not(.form--kirinus__step--last-step)').each(function () {
      let hasValue = false;

      const getTitle = $(this).find('.contact-multi-step__form-title').text();
      const newDiv = $('<div class="form--kirinus__summary-box"></div>');

      const getstep = $(this).data('step');

      newDiv.html(`<div class="d-flex flex-wrap"><p class="fw-bold">${getTitle}</p> <button class="btn p-0 mt-0 d-flex ms-auto" type="button" data-step="${getstep}"><span class="fa fa-edit"></span></button></div>`);

      $(this).find('.form__field').each(function () {
        const getClasses = this.classList;
        let getValue = '';
        let getLabel = '';

        if ($(this).attr('data-visible') !== 'false') {

          switch (true) {
            case getClasses.contains('form-select'):
              if ($(this).attr('data-label') !== 'false') {
                getLabel = `${$(this).parent().prev('.form-label').text()}`;
              }

              if ($(this).val() !== undefined) {
                getValue = $(this).find('option:selected').text();
              }
              break;
            case getClasses.contains('form-datepicker'):
              if ($(this).attr('data-label') !== 'false') {
                getLabel = `${$(this).parent().prev('.form-label').text()}`;
              }

              if ($(this).val() !== undefined) {
                getValue = $(this).val();
              }
              break;
            case getClasses.contains('form-check-input'):
              if ($(this).prop('checked') === true) {
                getValue = $(`[for="${$(this).attr('id')}"]`).text().trim();

                if ($(this).attr('data-label') !== 'false') {
                  getLabel = `${$(this).parent().parent().find('.form-label').text()}`;
                }
              }
              break;
            default:
              if ($(this).attr('data-label') !== 'false') {
                getLabel = `${$(this).parent().find('.form-label').text()}`;
              }
              getValue = $(this).val();
          }

          if (getValue.length !== 0) {
            let pTag = $('<p></p>').text(`${getValue}`);
            if ($(this).attr('data-label') !== 'false') {
              if ($(this)[0].type === 'textarea') {
                pTag = $('<div></div>').html(`${getLabel.replace('*','').trim()}: <br><pre>${getValue}</pre>`);
              } else {
                pTag = $('<p></p>').text(`${getLabel.replace('*','').trim()}: ${getValue}`);
              }
            }
            newDiv.append(pTag);
            hasValue = true;
          }
        }
      });

      if (hasValue === true) {
        $('.form--kirinus__summary').append(newDiv);
      }
    });

    $('.form--kirinus__summary .btn').each(function() {
      $(this).off('click').on('click', function(event) {
        event.stopPropagation();
        const getstep = $(this).attr('data-step');
        $(this).closest('.form--kirinus').attr('data-source-2', 'edit-button');

        $('.contact-multi-step__nav').children().eq((getstep - 1)).trigger('click');
      });
    });
  }

  getStep() {
    const maxStep = this.$navElement.parent().children().length;
    const currentStep = this.$navElement.parent().find('.active').index() + 1;
    const isSummary = this.$summary.parent().hasClass('active');

    visibleSummaryFirstTime ||= !!this.$summary.length && !!this.$form.find(".is-invalid").length;

    if (isSummary) {
      this.$stepPrev.hide();
      this.$stepNext.hide();
      this.$submit.show();
      this.$navElement.parent().removeClass(`${baseClass}__nav--show`);
      this.$stepBar.addClass(`${baseClass}__percent--hide`);
      visibleSummaryFirstTime = true;
      this.$stepNext.next().removeClass('is-show'); // Hide summary button
    } else if (currentStep === maxStep) {
      this.$stepPrev.show();
      this.$stepNext.hide();
      this.$submit.show();
    } else if (currentStep === 1) {
      this.$stepPrev.hide();
      this.$stepNext.show();
      this.$submit.hide();
      this.$navElement.parent().addClass(`${baseClass}__nav--show`);
      this.$stepBar.removeClass(`${baseClass}__percent--hide`);
      if (visibleSummaryFirstTime === true) {
        this.$stepNext.next().addClass('is-show'); // Show summary button
      }
    } else {
      this.$stepPrev.show();
      this.$stepNext.show();
      this.$submit.hide();
      this.$navElement.parent().addClass(`${baseClass}__nav--show`);
      this.$stepBar.removeClass(`${baseClass}__percent--hide`);
      if (visibleSummaryFirstTime === true) {
        this.$stepNext.next().addClass('is-show'); // Show summary button
      }
    }

    this.getSummary();

    // Hide navigation on confirmation finisher page
    if($(this.el).find(`.confirmation-finisher`).length) {
      this.$navElement.parent().removeClass(`${baseClass}__nav--show`);
      this.$stepBar.addClass(`${baseClass}__percent--hide`);
    }
  }

  onClick(e) {
    const target = e.currentTarget;
    const li = target.closest('li');
    const nodes = Array.from( li.closest('ul').children);
    const index = nodes.indexOf(li);

    if (!this.$lastStep.hasClass('active')) {
      // Abort execution if form is invalid
      if (!this.parsleyValidate()) return;
    }

    let getElementTarget = target.parentElement.className;

    let attr = this.$form.attr('data-source');
    let editBtn = this.$form.attr('data-source-2');

    if (typeof editBtn !== 'undefined' && editBtn !== false) {
      getElementTarget = editBtn;
      this.$form.removeAttr('data-source-2');
    } else if (typeof attr !== 'undefined' && attr !== false) {
      getElementTarget = attr;
      this.$form.removeAttr('data-source');
    }

   this.$form.attr('data-current-element', getElementTarget);

    this.dataLayer((index + 1),li.innerText);

    this.$navElement.removeClass('active');
    e.currentTarget.classList.add('active');

    this.$form.find(`.form--kirinus__step`).removeClass('active');

    this.$form.find(`.form--kirinus__step[data-step="${index + 1}"]`).addClass('active');

    this.$form.attr('data-current-position', `step${this.$form.find('.form--kirinus__step.active').attr('data-step')}`)

    if (this.$form.find('.form--kirinus__step.active').hasClass('form--kirinus__step--last-step')) {
      this.$form.attr('data-current-position', `conclusion`)
    }


    this.getStep();
    this.percentBar(index);
  }

  getStepsNumber() {
    return this.$navElement.parent().children().length - 1;
  }

  percentBar(step) {
    this.$stepBar.css('--last-step', this.getStepsNumber()).css('--current-step', (step + 1));
    this.$stepBar.find(`.${baseClass}__percent-number`).text(`${step + 1}/${this.getStepsNumber()}`);
  }

  getTime() {
    let currentdate = new Date();
    return `${currentdate.getDate()}.${(currentdate.getMonth()+1)}.${currentdate.getFullYear()} ${currentdate.getHours()}:${currentdate.getMinutes()}:${currentdate.getSeconds()}`;
  }

  dataLayer(step_level, step_name, submitForm = false, summaryBtn = null) {
    let getLocation = function (href) {
      let l = document.createElement('a');
      l.href = href;
      return l;
    };

    let l = getLocation(window.location.href);

    const level = step_level;
    const maxStep = this.$navElement.parent().children().length;

    let event_path = l.pathname + l.hash;
    let event_url = window.location.href;
    let step_count = (maxStep - 1);

    let currentLevel = step_level;

    //if (getActiveElementNumber) {
      //currentLevel = getActiveElementNumber;
    //}

    let step_source_event = this.$form.attr('data-current-element');
    if (summaryBtn === 'button-conclusion') {
      step_source_event = `button_conclusion`;
    } else if(this.$form.attr('data-current-element') === 'Nächster Schritt') {
      step_source_event = `button_forward_${this.$form.attr('data-current-position')}`;
    } else if(step_source_event === 'Zurück') {
      step_source_event = `button_back_${this.$form.attr('data-current-position')}`;
    } else if (step_source_event === 'button-conclusion') {
      step_source_event = `button_conclusion`;
    } else if (step_source_event === 'edit-button') {
      step_source_event = `edit_icon_conclusion`;
    } else if (step_source_event.includes('contact-multi-step__nav')) {
      step_source_event = `navigation_${this.$form.attr('data-current-position')}`;
    }

    if (timeStart === null) {
      timeStart = this.getTime();
    }

    if (step_source_event === 'edit_icon_conclusion') {
      conclusionAlreadySeen = 'yes';
    }

    if (maxStep === step_level) {
      step_level = 'contactform_multilevel_conclusion'
      step_name = 'Zusammenfassung';
      step_source_event = `button_forward_step${level - 1}`

      if (summaryBtn === 'button-conclusion') {
        step_source_event = `button_conclusion`;
      }
    } else {
      step_level = `contactform_multilevel_step${level}`
    }

    if (submitForm === true) {
      const formData = {
        'tracking_feature': 'kirinus_contactform_multilevel',
        'step_count': step_count,
        'step_level': 'contactform_multilevel_thankyou',
        'step_name': 'Dankeseite',
        'step_source_event': 'button_submit_form',
        'step_source': 'conclusion',
        'time_stamp_start': timeStart,
        'time_stamp_step': this.getTime(),
        'contact_multilevel_id': this.$form.attr('id')
      };

      const jsonData = JSON.stringify(formData);
      document.cookie = `multi_step_form_data=${jsonData}; path=/`;
    } else {
      pushTrackerEvent('contactform.multilevel', {
        'tracking_feature': 'kirinus_contactform_multilevel',
        'event_path': event_path,
        'event_url': event_url,
        'step_count': step_count,
        'step_level': step_level,
        'step_name': step_name,
        'step_source_event': step_source_event,
        'step_source': this.$form.attr('data-current-position') ? this.$form.attr('data-current-position') : 'direct-link',
        'time_stamp_start': timeStart,
        'time_stamp_step': this.getTime(),
        'contact_multilevel_id': this.$form.attr('id'),
        'conclusion_already_seen': conclusionAlreadySeen
      });
    }
  }

  submitForm() {
    let self = this;

    this.$form.find('[type="submit"]').on('click', function() {
      self.dataLayer('', '', true);
    });
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new MultiStepForm(el));
}


// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init
};
